import React from "react";

import { useEventsStore } from "../state";

import SearchIcon from "../assets/ui/search-white.png";

export default function () {
  const { showSearch, setShowSearch } = useEventsStore();
  const handleClick = () => {
    setShowSearch(!showSearch);
  };

  return (
    <img
      onClick={handleClick}
      src={SearchIcon}
      style={{ filter: "invert(100%)" }}
      alt="Search events"
      className="-ml-[5px] md:-ml-0"
    />
  );
}
